import React from "react"

import {OptionRow, Option} from "../Radio"
import Flex from "../../../Flex"
import {RadioOptionRow, RadioIconContainer, RadioIcon, RadioOptionText, MarginIconTooltip} from "./styled"

export interface ToolTipOption extends Option {
  tooltip: string
}
export interface ToolTipOptionRow extends OptionRow {
  option: ToolTipOption
}
const toolTipRenderer = (toolTipOptionRow: ToolTipOptionRow) => {
  const {option, checked} = toolTipOptionRow
  const {label, tooltip} = option

  return (
    <RadioOptionRow defaultRenderer>
      <RadioIconContainer>
        <RadioIcon checked={checked} />
      </RadioIconContainer>
      <Flex justifyContent="center" alignItems="center">
        <RadioOptionText small>{label}</RadioOptionText>
        {tooltip && (
          <Flex margin="0 0 0 5px">
            <MarginIconTooltip>{tooltip}</MarginIconTooltip>
          </Flex>
        )}
      </Flex>
    </RadioOptionRow>
  )
}

export default toolTipRenderer
